import { object, string } from 'yup';

export const customFormValidationSchema = object().shape({
  pluginMetadata: object().shape({
    verifyURL: string().required('Verification URL is required'),
    widgetUrl: string().when('action', {
      is: 'initWidget',
      then: (schema) => schema.required('Widget URL is required'),
      otherwise: (schema) => schema.nullable().notRequired()
    })
  })
});
